var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9997 68.64C57.9541 68.64 73.3197 53.2744 73.3197 34.32C73.3197 15.3656 57.9541 0 38.9997 0C20.0453 0 4.67969 15.3656 4.67969 34.32C4.67969 44.9926 9.55126 54.5274 17.192 60.822C17.2042 60.832 17.1934 60.8515 17.1784 60.8464C17.1693 60.8433 17.1597 60.8501 17.1597 60.8598V71.5042C17.1597 74.4834 20.2999 76.4171 22.9603 75.076L34.9717 69.0212C35.6351 68.6867 36.3783 68.5494 37.1202 68.5894C37.7425 68.623 38.3691 68.64 38.9997 68.64Z",
    fill: "#004440"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3007 24.3459C51.3598 25.158 51.562 26.674 50.7526 27.7352L38.7423 43.4825C38.3188 44.0377 37.6769 44.3827 36.9812 44.429C36.2856 44.4753 35.6039 44.2184 35.1109 43.7241L27.4879 36.081C26.5452 35.1358 26.5452 33.6059 27.4879 32.6607C28.4342 31.7119 29.971 31.7119 30.9172 32.6607L36.5779 38.3363L46.9028 24.799C47.7151 23.7339 49.2378 23.5309 50.3007 24.3459Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.6fbe43031148ee3b57b6a7384f8d9074.svg";
export { ForwardRef as ReactComponent };